import { UnifiedClassPersonSkillFullDTO } from "../dto/skills/UnifiedClassPersonSkillFullDTO";
import { UnifiedClassPersonSkill } from "../models/skills/UnifiedClassPersonSkill";
import { useUtility } from "@/composables/useUtility";

export const unifiedClassPersonSkillMapper = (
  dto: UnifiedClassPersonSkillFullDTO,
) => {
  const { mapPseudoBool } = useUtility();

  return new UnifiedClassPersonSkill({
    assignId: dto.assignId,
    personId: dto.personId,
    skillId: dto.skillId,
    skillName: dto.skillName,
    skillActive: mapPseudoBool(dto.skillActive) ?? false,
    skillDisplayOrder: dto.skillDisplayOrder,
    assessmentId: dto.assessmentId,
    assessmentName: dto.assessmentName,
    dateChanged: dto.dateChanged || null,
    instructor: dto.instructor || null,
    comments: dto.comments || null,
    jpClassSignupsSkillsAssignId: dto.jpClassSignupsSkillsAssignId || null,
  });
};
